import Page from "webPage/Page";
import Track from "../util/Track";
import Gallery from "webPage/Gallery";
import {loadGoogleMap} from "util/map";
import {loadPottingShedGoogleMap} from "util/map-potting-shed";
import {loadDaisyCottageGoogleMap} from "util/map-daisy-cottage";

let gallery;
let gallery_track;

Page.register('single-mphb_room_type', () => {

    new Track($('.js-track-wrap'), {
        classes: {
            block: "slider",
        },
    });


    let $gallery = $('.js-gallery');

    if ($gallery.length > 0) {
        gallery = new Gallery($gallery, {
            itemClass:          "gallery__main-image",
            pipClass:           "gallery-thumbnails__item",
            navigateClass:      "js-navigate",
            pipsClass:          "js-pips",
            itemsClass:         "js-items",
            itemActiveModifier: "active",
            pipActiveModifier:  "active",
            animationDuration:  0,
        });

        gallery.on('transitionStart', ({from, to}) => {
            // We need to ensure that the element is within the viewport
            updateTrackOffset(to);
            $('.js-gallery-current-page').text(to + 1);
        });

        let $gallery_track = $(".js-gallery-wrap");

        if ($gallery_track.length > 0) {
            gallery_track = new Track($gallery_track, {
                classes: {
                    block: "gallery",
                },
            });
        }
    }

    if ($("body").hasClass('postid-66')) {
        if ($('.js-google-map').length > 0) {
            loadPottingShedGoogleMap($('.js-google-map'));
        }
    } else if ($("body").hasClass('postid-64')) {
        if ($('.js-google-map').length > 0) {
            loadDaisyCottageGoogleMap($('.js-google-map'));
        }
    } else {
        if ($('.js-google-map').length > 0) {
            loadGoogleMap($('.js-google-map'));
        }
    }
});

export function updateTrackOffset(to = null) {
    if (to === null) {
        to = gallery.getActiveIndex();
    }
    let $to = gallery_track.getItems().eq(to);

    let offsetLeft = $to.position().left;
    let offsetRight = offsetLeft + $to.outerWidth();

    if (offsetLeft < gallery_track.getTransform()) {
        gallery_track.setTransform(offsetLeft - 4);
        return;
    }

    if (offsetRight > gallery_track.getTransform() + $('.js-gallery').innerWidth()) {
        gallery_track.setTransform(offsetRight - $('.js-gallery').innerWidth() + 4);
        return;
    }
}

